var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-title"},[_c('span',{staticClass:"title-text"},[_vm._v(_vm._s(_vm.title))]),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.back),expression:"back"}],staticClass:"back-btn",attrs:{"title":"返回"},on:{"click":_vm.handleBack}},[_c('i',{staticClass:"iconfont icon-fanhui"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }